module.exports = __webpack_public_path__ + "img/num3_active.6213d227.png";